import { useState } from 'react'

import { api } from '../api/client'
import type { AuditEntry, Page } from '../api/types'
import { Card, Empty, ErrorNote, Spinner, TableScroll, formatDateTime } from '../components/ui'
import { useQuery } from '../hooks/useApi'

const PAGE_SIZE = 50

export function AuditPage() {
  const [action, setAction] = useState('')
  const [objectType, setObjectType] = useState('')
  const [offset, setOffset] = useState(0)

  const entries = useQuery(
    () =>
      api.get<Page<AuditEntry>>('/audit', {
        action: action || undefined,
        object_type: objectType || undefined,
        limit: PAGE_SIZE,
        offset,
      }),
    [action, objectType, offset],
  )

  const total = entries.data?.total ?? 0

  return (
    <>
      <ErrorNote>{entries.error}</ErrorNote>

      <Card title={`Журнал аудита — ${total}`}>
        <div className="p-4 flex gap-3">
          <input
            className="input max-w-xs"
            placeholder="действие (incident.acknowledged)"
            value={action}
            onChange={(event) => {
              setOffset(0)
              setAction(event.target.value)
            }}
          />
          <input
            className="input max-w-xs"
            placeholder="тип объекта (incident)"
            value={objectType}
            onChange={(event) => {
              setOffset(0)
              setObjectType(event.target.value)
            }}
          />
        </div>

        {entries.loading && !entries.data ? (
          <Spinner />
        ) : (entries.data?.items.length ?? 0) === 0 ? (
          <Empty>Записей нет.</Empty>
        ) : (
          <TableScroll minWidth={720}>
            <thead>
              <tr>
                <th className="th">Время</th>
                <th className="th">Кто</th>
                <th className="th">Действие</th>
                <th className="th">Объект</th>
                <th className="th">IP</th>
                <th className="th">Correlation</th>
              </tr>
            </thead>
            <tbody>
              {entries.data!.items.map((entry) => (
                <tr key={entry.id}>
                  <td className="td text-slate-400 tabular-nums whitespace-nowrap">
                    {formatDateTime(entry.created_at)}
                  </td>
                  <td className="td">
                    {entry.actor_label}
                    <span className="ml-2 text-[11px] text-slate-500">{entry.actor_kind}</span>
                  </td>
                  <td className="td font-mono text-xs">{entry.action}</td>
                  <td className="td text-xs text-slate-400">
                    {entry.object_type}
                    <div className="font-mono text-[11px] text-slate-600">{entry.object_id}</div>
                  </td>
                  <td className="td text-xs text-slate-400">{entry.ip_address || '—'}</td>
                  <td className="td font-mono text-[11px] text-slate-500">
                    {entry.correlation_id ? entry.correlation_id.slice(0, 12) : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </TableScroll>
        )}

        <div className="flex items-center justify-between px-4 py-3 text-sm text-slate-400">
          <span>
            {total === 0 ? 0 : offset + 1}–{Math.min(offset + PAGE_SIZE, total)} из {total}
          </span>
          <div className="flex gap-2">
            <button
              className="btn-ghost"
              disabled={offset === 0}
              onClick={() => setOffset(Math.max(0, offset - PAGE_SIZE))}
            >
              Назад
            </button>
            <button
              className="btn-ghost"
              disabled={offset + PAGE_SIZE >= total}
              onClick={() => setOffset(offset + PAGE_SIZE)}
            >
              Вперёд
            </button>
          </div>
        </div>
      </Card>
    </>
  )
}
